import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { cancelOrderBooking, getOrderBookings } from "../ordersApi";

const ORDER_BOOKINGS_QUERY_KEY = "order-bookings";

export const useOrderBookings = (orderId: string) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading } = useQuery({
    queryKey: [ORDER_BOOKINGS_QUERY_KEY, orderId],
    queryFn: ({ signal }) => getOrderBookings(orderId, signal),
  });

  const cancelBookingMutation = useMutation<void, unknown, { bookingId: string }>({
    mutationFn: ({ bookingId }) => cancelOrderBooking(orderId, bookingId),
    onSuccess: async () => {
      enqueueSnackbar("Rezerwacja została anulowana", { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: [ORDER_BOOKINGS_QUERY_KEY, orderId] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się anulować rezerwacji. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return {
    bookings: data ?? [],
    isLoading,
    onCancel: (bookingId: string) => cancelBookingMutation.mutateAsync({ bookingId }),
  };
};
